/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { contentsRequestPaymentControllerCancel } from '../fn/contents-request-payment/contents-request-payment-controller-cancel';
import { ContentsRequestPaymentControllerCancel$Params } from '../fn/contents-request-payment/contents-request-payment-controller-cancel';
import { contentsRequestPaymentControllerCreate } from '../fn/contents-request-payment/contents-request-payment-controller-create';
import { ContentsRequestPaymentControllerCreate$Params } from '../fn/contents-request-payment/contents-request-payment-controller-create';
import { contentsRequestPaymentControllerDelete } from '../fn/contents-request-payment/contents-request-payment-controller-delete';
import { ContentsRequestPaymentControllerDelete$Params } from '../fn/contents-request-payment/contents-request-payment-controller-delete';
import { contentsRequestPaymentControllerFindByContentsRequestId } from '../fn/contents-request-payment/contents-request-payment-controller-find-by-contents-request-id';
import { ContentsRequestPaymentControllerFindByContentsRequestId$Params } from '../fn/contents-request-payment/contents-request-payment-controller-find-by-contents-request-id';
import { contentsRequestPaymentControllerFindById } from '../fn/contents-request-payment/contents-request-payment-controller-find-by-id';
import { ContentsRequestPaymentControllerFindById$Params } from '../fn/contents-request-payment/contents-request-payment-controller-find-by-id';
import { contentsRequestPaymentControllerPay } from '../fn/contents-request-payment/contents-request-payment-controller-pay';
import { ContentsRequestPaymentControllerPay$Params } from '../fn/contents-request-payment/contents-request-payment-controller-pay';
import { contentsRequestPaymentControllerUpdate } from '../fn/contents-request-payment/contents-request-payment-controller-update';
import { ContentsRequestPaymentControllerUpdate$Params } from '../fn/contents-request-payment/contents-request-payment-controller-update';
import { ContentsRequestPaymentDto } from '../models/contents-request-payment-dto';

@Injectable({ providedIn: 'root' })
export class ContentsRequestPaymentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `contentsRequestPaymentControllerFindByContentsRequestId()` */
  static readonly ContentsRequestPaymentControllerFindByContentsRequestIdPath = '/api/contents-request-payment/{id}/contentsRequest';

  /**
   * 콘텐츠 의뢰  ID 기반 조회.
   *
   * 콘텐츠 의뢰 결제를 콘텐츠 의뢰 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestPaymentControllerFindByContentsRequestId()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestPaymentControllerFindByContentsRequestId$Response(params: ContentsRequestPaymentControllerFindByContentsRequestId$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestPaymentDto>> {
    return contentsRequestPaymentControllerFindByContentsRequestId(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰  ID 기반 조회.
   *
   * 콘텐츠 의뢰 결제를 콘텐츠 의뢰 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestPaymentControllerFindByContentsRequestId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestPaymentControllerFindByContentsRequestId(params: ContentsRequestPaymentControllerFindByContentsRequestId$Params, context?: HttpContext): Observable<ContentsRequestPaymentDto> {
    return this.contentsRequestPaymentControllerFindByContentsRequestId$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestPaymentDto>): ContentsRequestPaymentDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestPaymentControllerFindById()` */
  static readonly ContentsRequestPaymentControllerFindByIdPath = '/api/contents-request-payment/{id}';

  /**
   * 콘텐츠 의뢰 결제 ID 기반 조회.
   *
   * 콘텐츠 의뢰 결제을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestPaymentControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestPaymentControllerFindById$Response(params: ContentsRequestPaymentControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestPaymentDto>> {
    return contentsRequestPaymentControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 결제 ID 기반 조회.
   *
   * 콘텐츠 의뢰 결제을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestPaymentControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestPaymentControllerFindById(params: ContentsRequestPaymentControllerFindById$Params, context?: HttpContext): Observable<ContentsRequestPaymentDto> {
    return this.contentsRequestPaymentControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestPaymentDto>): ContentsRequestPaymentDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestPaymentControllerDelete()` */
  static readonly ContentsRequestPaymentControllerDeletePath = '/api/contents-request-payment/{id}';

  /**
   * 콘텐츠 의뢰 결제 삭제.
   *
   * 콘텐츠 의뢰 결제을(를) 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestPaymentControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestPaymentControllerDelete$Response(params: ContentsRequestPaymentControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestPaymentDto>> {
    return contentsRequestPaymentControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 결제 삭제.
   *
   * 콘텐츠 의뢰 결제을(를) 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestPaymentControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestPaymentControllerDelete(params: ContentsRequestPaymentControllerDelete$Params, context?: HttpContext): Observable<ContentsRequestPaymentDto> {
    return this.contentsRequestPaymentControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestPaymentDto>): ContentsRequestPaymentDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestPaymentControllerUpdate()` */
  static readonly ContentsRequestPaymentControllerUpdatePath = '/api/contents-request-payment/{id}';

  /**
   * 콘텐츠 의뢰 결제 수정.
   *
   * 콘텐츠 의뢰 결제을(를) 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestPaymentControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestPaymentControllerUpdate$Response(params: ContentsRequestPaymentControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestPaymentDto>> {
    return contentsRequestPaymentControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 결제 수정.
   *
   * 콘텐츠 의뢰 결제을(를) 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestPaymentControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestPaymentControllerUpdate(params: ContentsRequestPaymentControllerUpdate$Params, context?: HttpContext): Observable<ContentsRequestPaymentDto> {
    return this.contentsRequestPaymentControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestPaymentDto>): ContentsRequestPaymentDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestPaymentControllerCreate()` */
  static readonly ContentsRequestPaymentControllerCreatePath = '/api/contents-request-payment';

  /**
   * 콘텐츠 의뢰 결제 생성.
   *
   * 콘텐츠 의뢰 결제을(를) 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestPaymentControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestPaymentControllerCreate$Response(params: ContentsRequestPaymentControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestPaymentDto>> {
    return contentsRequestPaymentControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 결제 생성.
   *
   * 콘텐츠 의뢰 결제을(를) 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestPaymentControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestPaymentControllerCreate(params: ContentsRequestPaymentControllerCreate$Params, context?: HttpContext): Observable<ContentsRequestPaymentDto> {
    return this.contentsRequestPaymentControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestPaymentDto>): ContentsRequestPaymentDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestPaymentControllerPay()` */
  static readonly ContentsRequestPaymentControllerPayPath = '/api/contents-request-payment/{clientWorkspaceId}/pay/{paymentId}';

  /**
   * 콘텐츠 의뢰 결제.
   *
   * 콘텐츠 의뢰 결제를 진행합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestPaymentControllerPay()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestPaymentControllerPay$Response(params: ContentsRequestPaymentControllerPay$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestPaymentDto>> {
    return contentsRequestPaymentControllerPay(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 결제.
   *
   * 콘텐츠 의뢰 결제를 진행합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestPaymentControllerPay$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestPaymentControllerPay(params: ContentsRequestPaymentControllerPay$Params, context?: HttpContext): Observable<ContentsRequestPaymentDto> {
    return this.contentsRequestPaymentControllerPay$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestPaymentDto>): ContentsRequestPaymentDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestPaymentControllerCancel()` */
  static readonly ContentsRequestPaymentControllerCancelPath = '/api/contents-request-payment/{id}/cancel';

  /**
   * 콘텐츠 의뢰 결제 취소.
   *
   * 콘텐츠 의뢰 결제를 취소합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestPaymentControllerCancel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestPaymentControllerCancel$Response(params: ContentsRequestPaymentControllerCancel$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestPaymentDto>> {
    return contentsRequestPaymentControllerCancel(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 결제 취소.
   *
   * 콘텐츠 의뢰 결제를 취소합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestPaymentControllerCancel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestPaymentControllerCancel(params: ContentsRequestPaymentControllerCancel$Params, context?: HttpContext): Observable<ContentsRequestPaymentDto> {
    return this.contentsRequestPaymentControllerCancel$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestPaymentDto>): ContentsRequestPaymentDto => r.body)
    );
  }

}
